
export class Protection{
    private protectionZone : string;
    private protectionType : number;
    private protectionLevel : number;

    constructor(prortectionZone:string, protectionType : number, protectionLevel:number){
        this.protectionType=protectionType;
        this.protectionZone=prortectionZone;
        this.protectionLevel=protectionLevel;
    }

    public getProtectionZone():string{
        return this.protectionZone;
    }

    public getProtectionType():number{
        return this.protectionType;
    }

    public getProtectionLevel():number{
        return this.protectionLevel;
    }
}